/* global axios */
import ApiClient from './ApiClient';

class SalesDashboardAPI extends ApiClient {
  constructor() {
    super('sales_dashboard', { accountScoped: true });
  }

  list(params = {}) {
    return axios.get(this.url, { params });
  }

  dashboard(params = {}) {
    return axios.get(`${this.url}/dashboard`, { params });
  }

  addresses(params = {}) {
    return axios.get(`${this.url}/addresses`, { params });
  }
}

export default new SalesDashboardAPI();
